module.exports = __webpack_public_path__ + "img/cs-tab-icon1.678fb9da.png";